<template lang="pug">
v-container(fluid)
  a(ref="downloadLink" hidden :href="graphData" download="grafo.png")
  v-toolbar(class="d-flex flex-row white--text" elevation="4" color="blue-grey" rounded)
    div(class="text-h4 mr-4") Consulta Familia Registral
    div(class="text-body-1") Traerá las matrículas <b>matrices</b> y <b>segregadas</b> que se encuentren disponibles en el sistema
  v-card(class="mt-4")
    v-form
      v-container(fluid)
        v-row
          v-col(class="py-0" cols="12" md="4" sm="12")
            fmi-picker(v-model="propertyRecord" ref="fmiNumber")
          v-col(class="d-flex py-0" cols="12" md="8" sm="12")
            //- Boton para cancelar la descarga de la familia registral
            v-btn(
              class="white--text"
              :loading="loadingCancel"
              :disabled="loadingCancel"
              v-if="celeryTaskId !== '' && vurMode"
              class="ma-2"
              color="red"
              @click="actionCancel")
              v-icon(class="mr-1" dark) mdi-cancel
              | Cancelar
            //- Boton para cargar familia registral
            v-tooltip(top v-if="!vurMode")
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  :disabled="loading"
                  :loading="loading"
                  ref="buttonSearch"
                  color="green"
                  small
                  class="ma-2 white--text"
                  v-bind="attrs"
                  v-on="on"
                  @click="search")
                  v-icon(left dark) mdi-magnify
                  | consultar
              span Graficar la familia registral del folio
            v-tooltip(v-if="graphData !== ''" top key="btnDownloadGraph")
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  color="orange"
                  class="ma-2 white--text"
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="download")
                  v-icon(left dark) mdi-family-tree
                  | Descargar Grafo
              span Descargar grafo familia en formato PNG
            v-tooltip(v-if="avalaibleCertificates.length > 0" top)
              template(v-slot:activator="{ on, attrs }")
                button-download-pdf(
                  :small="true"
                  class="mt-2"
                  v-bind="attrs"
                  v-on="on"
                  class="ml-2"
                  :folios="avalaibleCertificates")
              span Descargar PDFs de la familia disponibles en el sistema
            v-tooltip(v-if="graphData !== ''" top key="btnDownloadExcel")
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  color="green"
                  small
                  class="ma-2 white--text"
                  v-bind="attrs"
                  v-on="on"
                  title="Descargar Excel con información folios"
                  @click="downloadExcel")
                  v-icon(left dark) mdi-file-excel
                  | Descargar Excel
              span Descargar reporte excel de la familia registral
            v-tooltip(top)
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  color="red"
                  small
                  class="ma-2 white--text"
                  v-bind="attrs"
                  v-on="on"
                  @click="cleanFamily")
                  v-icon(left dark) mdi-broom
                  | Limpiar
              span Limpiar todos los datos de esta vista
            v-btn.mx-2.mt-2(
              fab
              dark
              small
              title="Desplegar Ayuda"
              @click="showHelp('FamilyHelp', 'Ayuda Familia Registral', '100%')"
              color='primary')
              v-icon(dark)
                | mdi-help-circle-outline
          v-col(class="d-flex py-0" cols="12" md="8")
            v-switch(
              v-if="hasPermission('can_use_vur')"
              v-model="vurMode"
              inset
              :label="vurMode ? 'Desactivar VUR' : 'Activar VUR'")
            v-divider.mx-3(vertical inset)
            div(v-if="vurMode" style="display:flex")
              span(class="mt-4 mr-4")
                v-icon(color="red" size="30") mdi-numeric-1-circle
              v-checkbox(
                class="mr-2"
                v-model="checkboxParent"
                label="Matrices")
              v-checkbox(
                class="mr-2"
                v-model="checkboxChildren"
                label="Segregadas")
              v-divider.mx-3(vertical inset v-if="graphFolioNumber !== ''")
              span(class="mt-4 mr-4" v-if="graphFolioNumber !== ''")
                v-icon(color="red" size="30")
                  | mdi-numeric-2-circle
              v-checkbox(
                class="mr-2"
                v-if="graphFolioNumber !== ''"
                style="width:max-content!important"
                v-model="checkboxMissing"
                label="Solo Faltantes")
              v-divider.mx-3(vertical inset)
              span(class="mt-4 mr-4")
                v-icon(color="red" size="30")
                  | | mdi-numeric-{{ graphFolioNumber !== '' ? '3' : '2'}}-circle
              v-tooltip(top)
                template(v-slot:activator="{ on, attrs }")
                  v-btn(
                    class="mt-4"
                    :disabled="loadingVurFamily"
                    :loading="loadingVurFamily"
                    color="green"
                    small
                    class="white--text"
                    v-bind="attrs"
                    v-on="on"
                    @click="searchVur")
                    v-icon(left dark) mdi-robot
                    | consulta VUR
                span Iniciar la descarga de la familia en VUR
            
  v-row
    v-col(:cols="truncatedFolios.length > 0 ? 9 : 12")
      folio-family-manager(class="mt-4")
    v-col(cols="3")
      v-card(class="mt-4")
        v-card-title Listado Matrículas Truncadas
        span(class="red--text px-3" style="width: -webkit-fill-available; display: block;")
          | En esta sección aparecerán los folios que no son mostrados
          | en la Familia registral por cuestión de rendimiento.
        v-list(class="my-0 py-0" dense)
          v-expansion-panels
            v-expansion-panel(v-for="(item,i) in truncatedFolios" :key="i")
              v-expansion-panel-header <b style="font-size:18px">{{ item.name }}</b> Matrículas Truncadas: {{truncatedRecords(item.truncated)}}
              v-expansion-panel-content
                span(v-if="item.truncated.parents.length > 0")
                  b(style="color:#F44336") Matrículas Matrices:
                  text-cutter(:text="item.truncated.parents.join(', ')"
                  modal-title="Matrículas segregadas matrices")
                span(v-if="item.truncated.children.length > 0")
                  b(style="color:#F44336") Matrículas Segregadas:
                  text-cutter(:text="item.truncated.children.join(', ')"
                  modal-title="Matrículas segregadas Truncadas")
</template>
  
<script>
import celeryMixin from '@/mixins/celeryMixin.js';
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import FolioFamilyManager from '@/components/folios/FolioFamilyManager.vue';
import FmiPicker from '@/components/ui/FmiPicker.vue';
import TextCutter from '@/components/TextCutter';
import ButtonDownloadPdf from '@/components/files/ButtonDownloadPdf';
import * as XLSX from 'xlsx';
import commonArkandhaMixin from '@/mixins/commonArkandhaMixin.js';

export default {
  name: 'FolioFamily',

  components: {    
    FolioFamilyManager,
    FmiPicker,
    TextCutter, 
    ButtonDownloadPdf,  
  },

  mixins: [celeryMixin, commonArkandhaMixin],

  data: () => ({
    propertyRecord: '',
    loading: false,
    checkboxParent: true,
    checkboxChildren: false,
    checkboxMissing: false,
    viewTruncated: true,
    alertMessage: `Consulta Familia Registral<br>
    <span class="text-body-1">Traerá las matrículas <b>matrices</b> y <b>segregadas</b> que se encuentren disponibles en el sistema</span>`
  }),

  computed: {
    ...mapGetters('auth', ['hasPermission']),
    ...mapGetters('folios', ['truncatedFolios']),
    ...mapState('folios', ['folioFamily', 'graphData', 'graphFolioNumber']),
    ...mapState('vur', ['vurMode', 'loadingVurFamily', 'celeryTaskId']),
    vurMode: {
      get() {
        return this.$store.state.vur.vurMode;
      },
      set(value) {
        return this.$store.commit('vur/CHANGE_VALUE', {
          value,
          varName: 'vurMode'
        });
      }
    },
    avalaibleCertificates() {
      return this.folioFamily.filter((x) => x.avalaible === true).map((x) => x.name);
    },
  },

  mounted() {
    if ('fmi' in this.$route.query) {
      // Inicializar el numero de matricula inmobiliaria
      const { fmi } = this.$route.query;
      const [circle, number] = fmi.split('-')
      this.$refs.fmiNumber.selectedCircle = circle;
      this.$refs.fmiNumber.recordText = number;
      this.$refs.fmiNumber.valid = true;
      this.propertyRecord = fmi;
      // ejecutar la funcion de consulta
      setTimeout(() => this.search(), 1000);
      // eliminar el parametro de la ruta
      window.history.replaceState({}, document.title, "/" + "family");
    }
    // realizar limpieza de la funcionalidad celery
    this.CHANGE_VALUE({
      varName: 'loadingVurFamily',
      value: false
    });
    this.CHANGE_VALUE({
      varName: 'celeryTaskId',
      value: ''
    });
  },

  methods: {
    ...mapActions('folios', ['searchFamily']),
    ...mapActions('vur', ['searchVurFamily', 'completeVurFamily']),
    ...mapMutations('ui', ['SHOW_ALERT']),
    ...mapMutations('folios', [
      'CLEAR_SEARCH',
      'CLEAN_FAMILY',
    ]),
    ...mapMutations('vur', ['CHANGE_VALUE']),
    // metodo para descargar el grafo png
    download() {
      this.$refs.downloadLink.click();
    },
    // metodo para realizar la busqueda de la familia registral
    async search() {
      if (!this.$refs.fmiNumber.validate()) {
        alert('Debe introducir un número de matrícula valido.')
        return
      }
      this.loading = true;
      try {
        await this.searchFamily({
          propertyRecord: this.propertyRecord,
        });
      } catch (error) {
        this.SHOW_ALERT({
          alertMessage:'Ocurrio un error al cargar la información',
          alertType: 'error'
        });
      }      
      this.loading = false;
    },
    // función para descargar los datos del VUR
    async searchVur() {
      // validar eque se haya introducido un numero de matricula valido
      if (!this.$refs.fmiNumber.validate()) {
        alert('Debe introducir un número de matrícula valido.')
        return
      }
      // Validar que se vayan a descargar matrice y/o segregados
      if (!this.checkboxChildren && !this.checkboxParent) {
        alert('Debe marcar por lo menos una de las opciones de tradición (Matrices o Segregadas).');
        return;
      }
      try {
        if (this.checkboxMissing === true) {
          await this.completeVurFamily({
            propertyRecord: this.propertyRecord,
            downloadParent: this.checkboxParent,
            downloadChildren: this.checkboxChildren,
          });
        } else {
          await this.searchVurFamily({
            propertyRecord: this.propertyRecord,
            downloadParent: this.checkboxParent,
            downloadChildren: this.checkboxChildren,
          });
        }
      } catch (error) {
        console.log(error);
        this.SHOW_ALERT({
          alertMessage:'Ocurrio un error al cargar la información',
          alertType: 'error'
        });
      }      
    },
    // método para calcular el número de matricular truncadas
    truncatedRecords(truncated) {
      return truncated.parents.length + truncated.children.length;
    },
    // metodo para descargar excel con la información de la familia
    downloadExcel() {
      const data = []
      for (let index = 0; index < this.folioFamily.length; index++) {
        const element = this.folioFamily[index];
        let relation = ''
        if (element.name === this.propertyRecord) {
          relation = 'Raíz'
        } else {
          relation = element.relation_type === 'PARENT' ? 'Matriz' : 'Segregado';
        }
        data.push([
          element.name,
          relation
        ]);
      }
      let dateString = new Date();
      dateString = dateString.toISOString().replace('T','_')
        .replace('Z','').replaceAll('-','_').replace(':','_').replace('.','_')
      // Crear una nueva hoja de cálculo
      const ws = XLSX.utils.aoa_to_sheet(data);

      // Crear un nuevo libro de trabajo
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Folios");

      // Generar y descargar el archivo Excel
      XLSX.writeFile(wb, `familia_${dateString}.xlsx`);
    },
    // metodo para limpiar la visya de familia registral
    cleanFamily() {
      // resetear los datos del componente
      this.propertyRecord =  '';
      this.loading = false;
      this.checkboxParent = true;
      this.checkboxChildren = false;
      this.checkboxMissing = false;
      this.viewTruncated = true;
      this.vurMode = false;
      this.$refs.fmiNumber.clear();
      this.CLEAN_FAMILY();
    }
  }
};
</script>